import { find, trim, toLower, get, has, } from 'lodash';
import academy from '@/assets/images/softwares/academy.png';
import academy_to_b from '@/assets/images/softwares/academy_to_b.png';
import analytic from '@/assets/images/softwares/Analytics.svg';
import bio from '@/assets/images/softwares/Bio.svg';
import chemical from '@/assets/images/softwares/Chemical.svg';
import discovery from '@/assets/images/softwares/discovery.png';
import inno from '@/assets/images/softwares/inno.png';
import insights from '@/assets/images/softwares/insights.png';
import backoffice from '@/assets/images/softwares/backoffice.png';
import connect from '@/assets/images/softwares/Open.svg';
import synapse from '@/assets/images/softwares/Synapse.svg';
import admin from '@/assets/images/softwares/admin.png';
import workspace from '@/assets/images/softwares/workspace.png';
import dashboard from '@/assets/images/softwares/dashboard.png';
import eureka from '@/assets/images/softwares/Eureka.svg';
const PRODUCT_ALIAS = {
    pro: 'database',
    report: 'insights',
};
export const PRODUCT_ICONS = {
    pro: analytic,
    database: analytic,
    analytic,
    course2b: academy_to_b,
    course: academy,
    academy,
    academy_to_b,
    bio,
    chemical,
    patsnap360: discovery,
    discovery,
    innosnap: inno,
    inno,
    report: insights,
    insights,
    backoffice,
    connect,
    synapse,
    workspace,
    dashboard,
    'developer center': connect,
    'admin console': admin,
    'admin portal': admin,
    'openapi-manager': backoffice,
    home: admin,
    account: admin,
    innosnap_product: inno,
    eureka,
};
export function getProductName(product, language) {
    if (language === 'cn') {
        return get(product, 'alias_cn', product?.name);
    }
    return get(product, 'alias_en', product?.name);
}
export function productIcon(allProducts, productInfoBase, language) {
    let productInfo = find(allProducts, p => p.product_id === productInfoBase.id);
    if (!productInfo) {
        productInfo = productInfoBase;
    }
    if (!productInfo.product_id) {
        productInfo.product_id = productInfoBase.id;
    }
    const product_name = trim(toLower(productInfo.product_name));
    return {
        ...productInfo,
        product_icon: get(PRODUCT_ALIAS, product_name, product_name),
        product_name: getProductName(productInfo, language),
    };
}
export function hasIcon(product) {
    return has(PRODUCT_ICONS, product.product_icon);
}
export function getIcon(product) {
    return PRODUCT_ICONS[product.product_icon];
}
